import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from '../../widgets/Selectors/WidgetBranchSelector'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import { wtApiCall, wtApiPostWithContentTypeHandling } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import WidgetEmployeeSelector from 'src/widgets/Selectors/WidgetEmployeeSelector'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import DataReportTable from './DataReportTable'
import Loading from 'src/helpers/commons/loader'
import { wtGetDateMonthYearFormat } from 'src/helpers/commons/moment'
import { useDownloadExcel } from 'react-export-table-to-excel'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { JobTypeOptions } from 'src/helpers/commons/dropdownOptions'

export default function EmployeeFamilyDetailReport() {
  const Base = new BaseListing()
  const [isLoading, setIsLoading] = useState(false)
  const [Employees, setEmployees] = useState([])
  const [EmployeeId, setEmployeeId] = useState(0)
  const [EmployeeName, setEmployeeName] = useState('')
  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [errors, setErrors] = useState([])
  const [isMore, setIsMore] = useState(false)
  const [reportData, setReportData] = useState([])
  const tableRef = useRef(null)
  const [JobType, setJobType] = useState('')
  const [ResignationStatus, setResignationStatus] = useState(0)

  const RESIGNATION_STATUS_ACTIVE = 0;
  const RESIGNATION_STATUS_RESIGNED = 1;
  const RESIGNATION_STATUS_TERMINATE = 2;
  const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
  const RESIGNATION_STATUS_RETIREMENT = 4;
  const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;

  const RESIGNATION_STATUS_NAME = {
    0: 'Active',
    1: 'Resigned',
    2: 'Terminated',
    3: 'Contract Discontinued',
    4: 'Retired',
    5: 'Passed Away',
  };

  const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
    { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
    { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
    { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
    { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
    { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
    { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  ];

  const generatePDF = () => {
    const doc = new jsPDF('portrait');
    const logo = 'assets/wil-icon.png';
    const img = new Image();
    let yPosition = 45;

    const headRows = [
      { content: 'Sr' },
      { content: 'ID' },
      { content: 'Employee Name' },
      { content: 'Designation' },
      { content: 'Relationship' },
      { content: 'Name' },
      { content: 'CNIC' },
      { content: 'DOB' },
      { content: 'Occupation' },
      { content: 'Entitled For Opd' }
    ];

    const body = [];

    reportData.forEach((employee, index) => {
      const family = employee.family_particular || [];
      const rowSpan = family.length || 1;

      family.forEach((member, memberIndex) => {
        const row = [];

        if (memberIndex === 0) {
          row.push({ content: String(index + 1), rowSpan, styles: { valign: 'middle' } });
          row.push({ content: String(employee.id ?? ''), rowSpan, styles: { valign: 'middle' } });
          row.push({ content: String(employee.full_name ?? ''), rowSpan, styles: { valign: 'middle', halign: 'left' } });
          row.push({ content: String(employee.designation?.name ?? ''), rowSpan, styles: { valign: 'middle', halign: 'left' } });
        } else {
          // row.push({ content: '' });
          // row.push({ content: '' });
          // row.push({ content: '' });
          // row.push({ content: '' });
        }

        row.push({ content: String(member?.relationship ?? '-') });
        row.push({ content: String(member?.name ?? '-') });
        row.push({ content: String(member?.cnic ?? '-') });
        row.push({ content: String(member?.date_of_birth ?? '-') });
        row.push({ content: String(member?.occupation ?? '-') });
        row.push({
          content: member?.entitled_for_opd === 1 || member.entitled_for_opd == 1 ? "Yes" : "No"
        });


        body.push(row);
      });

      if (family.length === 0) {
        const row = [
          { content: String(index + 1) },
          { content: String(employee.id ?? '') },
          { content: String(employee.full_name ?? ''), styles: { halign: 'left' } },
          { content: String(employee.designation?.name ?? ''), styles: { halign: 'left' } },
          { content: '-' },
          { content: '-' },
          { content: '-' },
          { content: '-' },
          { content: '-' }
        ];
        body.push(row);
      }
    });

    doc.autoTable({
      head: [headRows],
      body,
      startY: 40,
      margin: { top: 50, bottom: 20, left: 10, right: 10 },
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      styles: {
        lineColor: '#3c4b64',
        lineWidth: 0.2,
        halign: 'center',
        valign: 'middle',
        fontSize: 8
      },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        font: 'helvetica',
      },
      columnStyles: {
        0: { halign: 'center' },
        1: { halign: 'center' },
        2: { halign: 'left' },
        3: { halign: 'left' },
        4: { halign: 'center' },
        5: { halign: 'center' },
        6: { halign: 'center' },
        7: { halign: 'center' },
        8: { halign: 'center' },
      },
      didDrawPage: function (data) {
        const totalPages = doc.internal.getNumberOfPages();
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height || pageSize.getHeight();
        const pageWidth = pageSize.width || pageSize.getWidth();

        // Header
        doc.setTextColor('#3c4b64');
        doc.setFont('Helvetica', 'bold');
        doc.addImage(logo, 'PNG', pageWidth - 190, 3, 25, 25);
        doc.line(pageWidth - 164, 7, pageWidth - 164, 26);
        doc.setFontSize(11);
        doc.text('WAH', pageWidth - 162, 10, { align: 'left' });
        doc.setFont('Helvetica');
        doc.text('INDUSTRIES', pageWidth - 162, 15);
        doc.text('LIMITED', pageWidth - 162, 20);
        doc.setFontSize(9);
        doc.text('www.wahindustries.com', pageWidth - 162, 25);

        doc.setFontSize(14);
        doc.text('Employee Family Detail Report', pageWidth - 36, 12, { align: 'right' });

        // Page number
        const str = `Page ${doc.internal.getNumberOfPages()}`;
        doc.setTextColor('black');
        doc.text(str, 10, pageHeight - 4);
      },
    });

    // Footer timestamp
    doc.setFontSize(10);
    const printReport = 'This Report is printed through ERP at ' + moment().format('YYYY-MM-DD HH:mm:ss');
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const startX = (pageWidth - textWidth) / 2;
    const startY = doc.autoTable.previous.finalY + 20;
    doc.text(printReport, startX, startY);

    doc.save('EmployeeDetails.pdf');
  };



  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    if (key === 'employee_id') {
      setEmployeeId(val.value)
      setEmployeeName(val.label)
    }
    if (key === 'resignation_status') {
      setResignationStatus(val.value)
    }
  }

  const getReportData = () => {
    setIsLoading(true)
    wtApiCall(
      'reports/employee_family_details_report',
      {
        employee_id: EmployeeId,
        branch_id: branchId,
        department_id: department_id,
        designation_id: designation_id,
        resignation_status: ResignationStatus,
        job_status: JobType,
      },
      'get',
      (response) => {
        const { data } = response
        setReportData(data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Employee Family Report',
    sheet: 'Sheet',
  })

  const getPDFReportData = () => {
    wtApiCall(
      'employee_data_report',
      {},
      'get',
      (response) => {
        const { data } = response
        generatePDF(data)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }


  useEffect(() => {
    Base.dropdownData(
      'employees,branches,designations,departments',
      {},
      [setEmployees, setBranches, setDesignations, setDepartments],
      1,
    )
    // getData()
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Employee Family Detail Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Employee</label>
                        <WidgetEmployeeSelector
                          employees={Employees}
                          displayValue={EmployeeName}
                          value={EmployeeId}
                          placeholder="Select Employee"
                          onChange={(values) => changeValues('employee_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('employees', {}, [setEmployees], 1)
                          }
                        />
                        {errors.employee_id && <ErrorMessage messages={errors.employee_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('departments', {}, [setDepartments], 1)
                          }
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Designation</label>
                        <WidgetDesignationSelector
                          designations={designations}
                          displayValue={designation_name}
                          value={designation_id}
                          placeholder="Select Designation"
                          onChange={(values) => changeValues('designation_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('designations', {}, [setDesignations], 1)
                          }
                        />
                        {errors.designation_id && <ErrorMessage messages={errors.designation_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CButton
                        color="warning"
                        className="text-white"
                        onClick={() => setIsMore(!isMore)}
                        style={{ marginBottom: '20px', marginTop: '20px' }}
                      >
                        More
                      </CButton>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      <CButton
                        color="success"
                        className="text-white"
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                        onClick={onDownload}
                      >
                        Export
                      </CButton>
                      <CButton
                        color="danger"
                        className="text-white"
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                        onClick={generatePDF}
                      >
                        PDF
                      </CButton>
                    </CCol>
                  </CRow>
                  {isMore && (
                    <>
                      <CRow>
                        <CCol md={1}></CCol>

                        <CCol md={2}>
                          <CInputGroup>
                            <label>Job Type:</label>
                            <WidgetSelector
                              options={JobTypeOptions}
                              placeHolder={'Please Select'}
                              selectedValue={JobType}
                              onChange={(values) => setJobType(values.value)}
                            />
                            {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Resignation Status</label>
                            <WidgetSelector
                              options={RESIGNATION_STATUS_DROPDOWN_OPTIONS}
                              placeHolder={'Please Select'}
                              selectedValue={ResignationStatus}
                              onChange={(values) => changeValues('resignation_status', values)}

                            />
                            {errors.resignation_status && <ErrorMessage messages={errors.resignation_status} />}
                          </CInputGroup>
                        </CCol>
                      </CRow>
                    </>
                  )}

                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        <table className="table table-bordered data-table" ref={tableRef}>
          {isLoading ? (
            Loading
          ) : (
            <>
              {reportData.length > 0 ? (
                <DataReportTable
                  reportData={reportData}
                  setReportData={(data) => setReportData(data)}
                  isLoading={isLoading}
                />
              ) : (
                <center style={{ fontSize: '19px', fontWeight: 'bold' }}>No record to show...</center>
              )}
            </>
          )}
        </table>

      </div>
    </>
  )
}
